<div class="redirect-page p-py-6 p-text-center">
  <p-progressSpinner></p-progressSpinner>
</div>

<myc-invisible-re-captcha
  (error)="onRecaptchaError()"
  (expired)="onRecaptchaExpired()"
  (loaded)="onRecaptchaLoaded($event)"
  (solved)="onRecaptchaSolved($event)"
  [siteKey]="recaptchaSiteKey$ | async"
></myc-invisible-re-captcha>
